import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Feedback } from '@telus-uds/components-web';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(_error: Error, _errorInfo: ErrorInfo): void {}

  render(): ReactNode {
    if (this.state.hasError) {
      if (this.props.fallback !== undefined) {
        return this.props.fallback;
      }

      return (
        <Feedback validation='error' variant={{ icon: true }} title="Something went wrong">
          {this.state.error?.message || 'An unexpected error occurred'}
        </Feedback>
      );
    }

    return this.props.children;
  }
}
